import { COLLABORATORS_MANAGEMENT_ROLES, REJECTED_CANDIDATES_ALLOWED_ROLES } from "@/constants/userPermissions";
import { RouteEntry } from "@/interfaces/route";
import { withDepartmentPrefix } from "@/utils/department-routes";
import { RoutePathEnum } from "./paths";

// Helper para extrair segmento raiz de um path completo
const segment = (path: RoutePathEnum) => path.replace("/", "");

const routesEntries: RouteEntry[] = [
  withDepartmentPrefix([
    {
      path: segment(RoutePathEnum.TALENTS),
      name: "Talentos",
      isNavItem: true,
      children: [
        {
          path: "[id]",
          name: "Detalhes do talento",
          children: [
            {
              path: "dados-talento",
              name: "Dados do talento",
              isNavItem: true,
              children: [
                {
                  path: "editar",
                  name: "Editar talento",
                },
              ],
            },
            {
              path: "book",
              name: "Book",
              isNavItem: true,
            },
            {
              path: "composites",
              name: "Composites",
              isNavItem: true,
              children: [
                {
                  path: "criar",
                  name: "Criar composite",
                },
                {
                  path: "editar/[compositeId]",
                  name: "Editar composite",
                },
              ],
            },
            {
              path: "documentos",
              name: "Documentos",
              isNavItem: true,
            },
            {
              path: "contratos",
              name: "Contratos",
              isNavItem: true,
            },
            {
              path: "historico-jobs",
              name: "Histórico de jobs",
              isNavItem: true,
            },
          ],
        },
        {
          path: "cadastrar",
          name: "Cadastrar talento",
        },
      ],
    },
    {
      path: segment(RoutePathEnum.TALENTS_ARCHIVED),
      name: "Arquivados",
      isNavItem: true,
    },
    {
      path: segment(RoutePathEnum.JOBS),
      name: "Jobs",
      isNavItem: true,
      children: [
        {
          path: "novo-job",
          name: "Novo job",
        },
        {
          path: "[id]/[stageId]",
          name: "Casting",
          children: [
            {
              path: "editar-job",
              name: "Editar dados",
            },
          ],
        },
        {
          path: "[id]/casting",
          name: "Casting",
          children: [
            {
              path: "talentos-selecionados",
              name: "Talentos Selecionados",
            },
          ],
        },
        {
          path: "[id]/pre-selecao",
          name: "Pré-Seleção",
        },
        {
          path: "[id]/editados",
          name: "Editados",
        },
        {
          path: "[id]/aprovados",
          name: "Aprovação",
        },
      ],
    },
    {
      path: segment(RoutePathEnum.COLLABORATORS),
      name: "Colaboradores",
      isNavItem: true,
      auth: {
        roles: COLLABORATORS_MANAGEMENT_ROLES,
      },
    },
    {
      path: segment(RoutePathEnum.SCHEDULE),
      name: "Agenda",
      isNavItem: true,
      children: [
        {
          path: "[scheduleId]",
          name: "Ficha do agendado",
          children: [
            {
              path: "dados-talento",
              name: "Dados do talento",
            },
            {
              path: "producao",
              name: "Produção",
            },
            {
              path: "contratos",
              name: "Contratos",
            },
            {
              path: "producao-artistica",
              name: "Produção artística",
            },
            {
              path: "fotografia",
              name: "Fotografia",
            },
          ],
        },
      ],
    },
    {
      path: segment(RoutePathEnum.REJECTED),
      name: "Reprovados",
      isNavItem: true,
      auth: { roles: REJECTED_CANDIDATES_ALLOWED_ROLES },
    },
    {
      path: segment(RoutePathEnum.MY_ACCOUNT),
      name: "Minha conta",
    },
  ]),
];

export default routesEntries;
